<!-- 仓位编辑页面 -->
<template>
    <div v-loading="loading">
        <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%; padding-right: 30px" :rules="rules">
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="仓位编号" prop="Code">
                        <el-input v-model.trim="submitData.Code"> </el-input>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="仓位名称">
                        <el-input style="width: 100%" v-model.trim="submitData.Name"> </el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-bottom">
                <el-form-item label="用途">
                    <el-input style="width: 100%" v-model.trim="submitData.UseDesc"> </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input style="width: 100%" v-model.trim="submitData.Remark"> </el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="submitData.SpaceType" style="width: 50%" placeholder="请选择">
                        <el-option v-for="item in spaceTypeList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="submitData.State" style="width: 50%" placeholder="请选择">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设置区域">
                    <el-select v-model="submitData.ZoneId" style="width: 50%" placeholder="请选择">
                        <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"> </el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm">提交</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['ShelfSpaceId', 'WarehouseId'],
    components: {},
    data() {
        return {
            loading: false,
            canRequest: true,
            submitData: {
                WarehouseId: '',
                ShelfSpaceId: '',
                Name: '',
                UseDesc: '',
                Code: '',
                State: 0,
                Remark: '',
                SpaceType: 0,
                ZoneId:''
            },
            stateList: [
                { Value: 0, Text: '正常使用' },
                { Value: 1, Text: '暂停使用' }
            ],
            spaceTypeList: [
                { Value: 0, Text: '标准仓' },
                { Value: 1, Text: '临时仓' },
                { Value: 2, Text: '废品仓' }
            ],
            rules: {
                Code: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            zoneList:{}
        };
    },
    mounted() {
        this.getZoneList();
        this.submitData.WarehouseId = this.WarehouseId;
        // 编辑
        if (this.ShelfSpaceId) {
            this.submitData.ShelfSpaceId = this.ShelfSpaceId;
            this.getPosition();
        }
    },
    methods: {
        submitForm() {
            let that = this;
            that.$refs.formMsg.validate(valid => {
                if (valid) {
                    if (!that.canRequest) {
                        return;
                    }
                    that.canRequest = false;
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpShelfSpaces/Save',
                            data: that.submitData,
                            hideLoading: true
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.$emit('closeDialog', true);
                        })
                        .catch(() => {
                            that.canRequest = true;
                            that.loading = false;
                        });
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        getPosition() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetEnterpriseGoodsLocation',
                    data: {
                        ShelfSpaceId: that.ShelfSpaceId,
                        WarehouseId: that.WarehouseId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    data.WarehouseId = that.WarehouseId;
                    data.ShelfSpaceId = that.ShelfSpaceId;
                    that.submitData = res.data;
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        getZoneList() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneDataList',
                    data: {
                        WarehouseId: that.WarehouseId
                    }
                })
                .then(res => {
                    that.zoneList = res.data;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;
    > div {
        width: 50%;
    }
}
.dialog-footer {
    text-align: right;
}
</style>
